var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityFinanceTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.127,
    height: 41,
    viewBox: "0 0 48.127 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vehicles",
    transform: "translate(0 -31.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55449",
    "data-name": "Path 55449",
    d: "M44.577,338.938v3.086a2.243,2.243,0,0,0,2.243,2.243h3.507a2.243,2.243,0,0,0,2.243-2.243v-3.086Z",
    transform: "translate(-39.556 -272.966)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55450",
    "data-name": "Path 55450",
    d: "M56.573,31.325H38.586a7.654,7.654,0,0,0-7.654,7.654V67.3H63.106V37.858A6.533,6.533,0,0,0,56.573,31.325Z",
    transform: "translate(-27.448 0)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3385",
    "data-name": "Rectangle 3385",
    width: 15.883,
    height: 3.177,
    transform: "translate(12.219 34.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2825",
    "data-name": "Ellipse 2825",
    cx: 3.074,
    cy: 3.074,
    r: 3.074,
    transform: "translate(8.108 57.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48188",
    "data-name": "Group 48188",
    transform: "translate(0 43.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55451",
    "data-name": "Path 55451",
    d: "M1.962,143.737A1.962,1.962,0,0,0,0,145.7v5.092a1.962,1.962,0,0,0,1.962,1.962H3.791v-9.017H1.962Z",
    transform: "translate(0 -143.737)",
    fill: "#3ea69b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55452",
    "data-name": "Path 55452",
    d: "M318.417,143.738h-1.829v9.017h1.829a1.962,1.962,0,0,0,1.962-1.962V145.7A1.962,1.962,0,0,0,318.417,143.738Z",
    transform: "translate(-280.93 -143.738)",
    fill: "#3ea69b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55462",
    "data-name": "Path 55462",
    d: "M0,0H23.668V12.808H0Z",
    transform: "translate(8.118 42.097)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55453",
    "data-name": "Path 55453",
    d: "M71.869,139.777V126.969h23.67Z",
    transform: "translate(-63.751 -84.871)",
    fill: "#c5e0dc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48189",
    "data-name": "Group 48189",
    transform: "translate(24.867 68.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55454",
    "data-name": "Path 55454",
    d: "M220.156,362.591v1.585a2.1,2.1,0,0,0,2.1,2.1h1.53a2.1,2.1,0,0,0,2.1-2.1v-1.585Z",
    transform: "translate(-220.156 -362.591)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55455",
    "data-name": "Path 55455",
    d: "M344.487,362.591v1.585a2.1,2.1,0,0,0,2.1,2.1h1.53a2.1,2.1,0,0,0,2.1-2.1v-1.585Z",
    transform: "translate(-330.483 -362.591)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48190",
    "data-name": "Group 48190",
    transform: "translate(21.742 60.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55456",
    "data-name": "Path 55456",
    d: "M401.264,290.267H398.92v2.152h2.344a.781.781,0,0,0,.781-.781v-.59A.781.781,0,0,0,401.264,290.267Z",
    transform: "translate(-375.66 -290.267)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55457",
    "data-name": "Path 55457",
    d: "M193.19,290.266a.781.781,0,0,0-.781.781v.59a.781.781,0,0,0,.781.781h2.344v-2.152H193.19Z",
    transform: "translate(-192.409 -290.266)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55458",
    "data-name": "Path 55458",
    d: "M231.334,227.95h-8.729a6.087,6.087,0,0,0-6.087,6.087v9.693h20.9v-9.693A6.087,6.087,0,0,0,231.334,227.95Z",
    transform: "translate(-192.061 -174.479)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55459",
    "data-name": "Path 55459",
    d: "M236.408,247.14H252.7a6.819,6.819,0,0,0-2.485-6.153,1.356,1.356,0,0,0-.871-.3h-9.417a1.4,1.4,0,0,0-.986.407C237.985,242.035,235.847,244.494,236.408,247.14Z",
    transform: "translate(-209.628 -185.779)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3387",
    "data-name": "Rectangle 3387",
    width: 8.146,
    height: 3.177,
    transform: "translate(19.964 34.72)",
    fill: "#e1e6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55460",
    "data-name": "Path 55460",
    d: "M236.408,247.14c-.561-2.647,1.577-5.105,2.532-6.049a1.4,1.4,0,0,1,.986-.407h9.417a1.356,1.356,0,0,1,.871.3Z",
    transform: "translate(-209.644 -185.779)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48191",
    "data-name": "Group 48191",
    transform: "translate(27.38 63.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2826",
    "data-name": "Ellipse 2826",
    cx: 1.783,
    cy: 1.783,
    r: 1.783,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2827",
    "data-name": "Ellipse 2827",
    cx: 1.783,
    cy: 1.783,
    r: 1.783,
    transform: "translate(10.793 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityFinanceTransport);
export default __webpack_public_path__ + "static/media/university-finance-transport.44d1cfbeb2445491726341c812ddf97a.svg";
export { ForwardRef as ReactComponent };